import PropTypes from 'prop-types';

// same questions as ./DisabledCheckIcon
const EnabledCheckIcon = ({ width = 17, height = 16 }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} fill='none' viewBox='0 0 17 16'>
      <rect width='16' height='16' x='0.5' fill='#1B4332' rx='8'></rect>
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M12.2 5.3c-.4-.4-1-.4-1.4 0L7.5 8.6 6.2 7.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
};

EnabledCheckIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

export default EnabledCheckIcon;
